import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Arimo', 'Helvetica', 'Arial', sans-serif",
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Arimo', sans-serif",
          fontWeight: 600,
          letterSpacing: '-0.5px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "'Arimo', sans-serif",
          fontWeight: 600,
          letterSpacing: '-0.5px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Arimo', sans-serif",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontFamily: "'Arimo', sans-serif",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "'Arimo', sans-serif",
        },
      },
    },
  },
});

export default theme;
